import React from "react";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";

const LaunchingSoon = () => {
  return (
    <>
      <div className="container-fluid vh-100 d-flex justify-content-center align-items-center bg-light">
        <Container>
          <div className="text-center">
            <h2 className="texteYantra py-3 fs-48">Launching Soon....</h2>
            <Link to="/" className="text-decoration-none" id="btnCTA">
              Go back to Home
            </Link>
          </div>
        </Container>
      </div>
    </>
  );
};

export default LaunchingSoon;
